import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { RichText } from "prismic-dom";
import { Box, Flex } from "rebass";
import {
  Head,
  H1,
  H2,
  H3,
  H4,
  Text,
  UpdateCard,
  CardLayout,
  Select,
  FilterBar,
  Main,
  PageHeader,
  PageSection,
  Article,
  CalloutCard,
  CalloutContainer,
  PageContent,
  PageSidebar,
  PrimaryButton,
} from "components";

import Link from "gatsby-link";

const UpdateLayout = styled(Flex)`
  align-items: stretch;

  @media (max-width: 30em) {
    flex-wrap: wrap;
    > * {
      width: 100%;
      margin-bottom: ${(props) => props.theme.space[1]}px;

      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    > *:last-child {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    }
  }
  @media (min-width: 30em) {
    flex-wrap: wrap;
    > * {
      width: ${(props) =>
        "calc(" + (1 / 2) * 100 + "% - " + props.theme.space[4] / 2 + "px)"};
      margin-bottom: ${(props) => props.theme.space[5]}px;

      &:not(:lang(ar)) {
        margin-left: ${(props) => props.theme.space[4]}px;
      }
      &:lang(ar) {
        margin-right: ${(props) => props.theme.space[4]}px;
      }
    }
    > *:nth-child(2n + 1) {
      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    > *:nth-last-child(-n + 2) {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    }
  }
`;

const Prismic = require("prismic-javascript");

let linkResolver = function (doc) {
  return "/" + doc.type;
};

class Updates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updates: [],
      updateLimit: 12,
      updatePage: 1,
      campaign: "",
      region: "",
      institution: "",
    };
  }

  static contextTypes = {
    setAltLanguages: PropTypes.func,
  };

  componentDidMount() {
    this.context.setAltLanguages(undefined);
    this.setFiltersFromPath();
  }

  changeRegion = (event) => {
    this.setState({ region: event.target.value }, () => {
      this.getUpdates(false);
    });
  };

  changeCampaign = (event) => {
    this.setState({ campaign: event.target.value }, () => {
      this.getUpdates(false);
    });
  };

  changeInstitution = (event) => {
    this.setState({ institution: event.target.value }, () => {
      this.getUpdates(false);
    });
  };

  getUpdates = (add) => {
    let predicates = [
      Prismic.Predicates.at("document.type", "update"),
      Prismic.Predicates.not("my.update.uid", "hidden-update"),
    ];
    if (this.state.region !== "") {
      predicates.push(
        Prismic.Predicates.at("my.update.region", this.state.region)
      );
    }
    if (this.state.institution !== "") {
      predicates.push(
        Prismic.Predicates.at("my.update.institution", this.state.institution)
      );
    }
    let page = 1;
    if (add) {
      page = this.state.updatePage + 1;
    }
    // if campaign is null, do a standard query, else..
    if (this.state.campaign === "") {
      Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2")
        .then((api) => {
          return api.query(predicates, {
            lang: this.props.data.page.lang,
            fetchLinks: "region.uid",
            page: page,
            pageSize: this.state.updateLimit,
            orderings: "[my.update.publish_date desc]",
          });
        })
        .then((response) => {
          if (!add) {
            this.setState({ updates: response.results, updatePage: 1 });
          } else {
            let updatesCurrent = JSON.parse(JSON.stringify(this.state.updates));
            let updates = updatesCurrent.concat(response.results);
            this.setState({ updates: updates, updatePage: page });
          }
        });
    } else {
      let predicates1 = JSON.parse(JSON.stringify(predicates));
      let predicates2 = JSON.parse(JSON.stringify(predicates));
      let predicates3 = JSON.parse(JSON.stringify(predicates));
      let predicates4 = JSON.parse(JSON.stringify(predicates));
      if (this.state.campaign !== "") {
        predicates1.push(
          Prismic.Predicates.at("my.update.campaign", this.state.campaign)
        );
        predicates2.push(
          Prismic.Predicates.at("my.update.campaign2", this.state.campaign)
        );
        predicates3.push(
          Prismic.Predicates.at("my.update.campaign3", this.state.campaign)
        );
        predicates4.push(
          Prismic.Predicates.at("my.update.campaign4", this.state.campaign)
        );
      }
      let results = [];
      // query four times to get them all
      Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2")
        .then((api) => {
          return api.query(predicates1, {
            lang: this.props.data.page.lang,
            fetchLinks: "region.uid",
            page: page,
            pageSize: this.state.updateLimit,
            orderings: "[my.update.publish_date desc]",
          });
        })
        .then((response) => {
          results = [...results, ...response.results];
          Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2")
            .then((api) => {
              return api.query(predicates2, {
                lang: this.props.data.page.lang,
                fetchLinks: "region.uid",
                page: page,
                pageSize: this.state.updateLimit,
                orderings: "[my.update.publish_date desc]",
              });
            })
            .then((response2) => {
              results = [...results, ...response2.results];
              Prismic.getApi(
                "https://bankinformationcenter.cdn.prismic.io/api/v2"
              )
                .then((api) => {
                  return api.query(predicates3, {
                    lang: this.props.data.page.lang,
                    fetchLinks: "region.uid",
                    page: page,
                    pageSize: this.state.updateLimit,
                    orderings: "[my.update.publish_date desc]",
                  });
                })
                .then((response3) => {
                  results = [...results, ...response3.results];
                  Prismic.getApi(
                    "https://bankinformationcenter.cdn.prismic.io/api/v2"
                  )
                    .then((api) => {
                      return api.query(predicates4, {
                        lang: this.props.data.page.lang,
                        fetchLinks: "region.uid",
                        page: page,
                        pageSize: this.state.updateLimit,
                        orderings: "[my.update.publish_date desc]",
                      });
                    })
                    .then((response4) => {
                      results = [...results, ...response4.results].sort(
                        (a, b) => {
                          return a.data.publish_date > b.data.publish_date
                            ? -1
                            : 1;
                        }
                      );
                      if (!add) {
                        this.setState({ updates: results, updatePage: 1 });
                      } else {
                        let updatesCurrent = JSON.parse(
                          JSON.stringify(this.state.updates)
                        );
                        let updates = updatesCurrent.concat(results);
                        this.setState({ updates: updates, updatePage: page });
                      }
                    });
                });
            });
        });
    }
  };

  setFiltersFromPath = () => {
    if (this.props.location.search.indexOf("campaign") !== -1) {
      this.setState(
        { campaign: this.props.location.search.split("=")[1] },
        () => {
          this.getUpdates(false);
        }
      );
    }
    if (this.props.location.search.indexOf("institution") !== -1) {
      this.setState(
        { institution: this.props.location.search.split("=")[1] },
        () => {
          this.getUpdates(false);
        }
      );
    }
    if (this.props.location.search.indexOf("region") !== -1) {
      this.setState(
        { region: this.props.location.search.split("=")[1] },
        () => {
          this.getUpdates(false);
        }
      );
    }
    if (
      this.props.location.search.indexOf("region") === -1 &&
      this.props.location.search.indexOf("institution") === -1 &&
      this.props.location.search.indexOf("campaign") === -1
    ) {
      this.getUpdates(false);
    }
  };

  render() {
    let json = undefined;
    if (this.props.data.page.raw) {
      json = JSON.parse(this.props.data.page.raw);
    }
    if (this.props.data.regions) {
      this.props.data.regions.edges.sort(function (a, b) {
        if (a.node.uid < b.node.uid) return -1;
        if (a.node.uid > b.node.uid) return 1;
        return 0;
      });
    }
    return (
      <div
        style={
          this.props.transition ? this.props.transition.style : { opacity: 0 }
        }
      >
        <Head source={json.data} />
        <Main>
          <PageHeader title={json.data.title[0].text} color={json.uid}>
            {json.data.subtitle[0] && (
              <H2 children={json.data.subtitle[0].text} fontSize={[4, 5]} />
            )}
            {json.data.description[0] && (
              <Text children={json.data.description[0].text} />
            )}
          </PageHeader>
          <PageSection>
            {json.data.body1[0] && (
              <PageSidebar>
                {json.data.body1.map((callout, index) => (
                  <CalloutCard
                    key={"callout" + index}
                    callout={callout.primary}
                    lang={json.lang}
                  />
                ))}
              </PageSidebar>
            )}
            <PageContent>
              {json.data.body && (
                <Article
                  dangerouslySetInnerHTML={{
                    __html: RichText.asHtml(json.data.body, linkResolver),
                  }}
                />
              )}
              <Box my={6}>
                <FilterBar lang={json.lang}>
                  {/* <Select>
                    <option value="">Most Recent</option>
                    <option value="">Oldest First</option>
                    <option value="">Alphabetical (A-Z)</option>
                    <option value="">Reverse Alphabetical (Z-A)</option>
                  </Select> */}
                  <Select
                    onChange={this.changeRegion}
                    value={this.state.region}
                    aria-label="Filter by Region"
                  >
                    <option value="">
                      {json.lang === "en-us"
                        ? "All Regions"
                        : json.lang === "es-mx"
                        ? "Todas las regiones"
                        : "كل المناطق"}
                    </option>
                    {this.props.data.regions.edges.map((region, index) => (
                      <option
                        children={region.node.data.title[0].text}
                        value={region.node.prismicId}
                        key={"region" + index}
                      />
                    ))}
                  </Select>
                  <Select
                    onChange={this.changeCampaign}
                    value={this.state.campaign}
                    aria-label="Filter by Campaign"
                  >
                    <option value="">
                      {json.lang === "en-us"
                        ? "All Campaigns"
                        : json.lang === "es-mx"
                        ? "Todas las campañas"
                        : "كل المناطق"}
                    </option>
                    {this.props.data.campaigns.edges.map((campaign, index) => (
                      <option
                        children={campaign.node.data.title[0].text}
                        value={campaign.node.prismicId}
                        key={"campaign" + index}
                      />
                    ))}
                  </Select>
                  <Select
                    onChange={this.changeInstitution}
                    value={this.state.institution}
                    aria-label="Filter by Institution"
                  >
                    <option value="">
                      {json.lang === "en-us"
                        ? "All Institutions"
                        : json.lang === "es-mx"
                        ? "Todas las instituciones"
                        : "جميع المؤسسات"}
                    </option>
                    {this.props.data.institutions.edges.map(
                      (institution, index) => (
                        <option
                          children={institution.node.data.title[0].text}
                          value={institution.node.prismicId}
                          key={"institution" + index}
                        />
                      )
                    )}
                  </Select>
                </FilterBar>
              </Box>
              {this.state.updates && (
                <UpdateLayout>
                  {this.state.updates.map((update, index) => (
                    <UpdateCard
                      key={"update" + index}
                      object={update}
                      institutions={this.props.data.institutions.edges}
                      campaigns={this.props.data.campaigns.edges}
                    />
                  ))}
                </UpdateLayout>
              )}
              {this.state.updates.length !==
                this.state.updateLimit * this.state.updatePage && (
                <Flex width="100%" justify="center">
                  <Box pt={6} style={{ textAlign: "center" }}>
                    <Text
                      children={
                        json.lang === "en-us"
                          ? "Didn't find what you are looking for?"
                          : json.lang === "es-mx"
                          ? "¿No encontró lo que estaba buscando?"
                          : "لم تجد ما تبحث عنه؟"
                      }
                      mb={3}
                    />
                    <PrimaryButton
                      children={
                        json.lang === "en-us"
                          ? "Get in touch"
                          : json.lang === "es-mx"
                          ? "Póngase en contacto"
                          : "اتصل بنا"
                      }
                      is={Link}
                      to={"/" + json.lang + "/contact"}
                    />
                  </Box>
                </Flex>
              )}
              {this.state.updates.length ===
                this.state.updateLimit * this.state.updatePage && (
                <Flex width="100%" justify="center">
                  <Box pt={6}>
                    <PrimaryButton
                      children={
                        json.lang === "en-us"
                          ? "View More"
                          : json.lang === "es-mx"
                          ? "Ver más"
                          : "عرض المزيد"
                      }
                      onClick={() => {
                        this.getUpdates(true);
                      }}
                    />
                  </Box>
                </Flex>
              )}
            </PageContent>
          </PageSection>
        </Main>
      </div>
    );
  }
}

export default Updates;

export const query = graphql`
  query UpdatesQuery($id: String!, $lang: String!) {
    page: prismicDocument(prismicId: { eq: $id }) {
      raw
      uid
      id
      lang
      data {
        title {
          type
          text
        }
        meta_title {
          text
        }
        meta_description {
          text
        }
        social_sharing_image {
          url
        }
      }
    }
    regions: allPrismicDocument(
      filter: { type: { eq: "region" }, lang: { eq: $lang } }
    ) {
      edges {
        node {
          uid
          prismicId
          data {
            title {
              text
            }
          }
        }
      }
    }
    campaigns: allPrismicDocument(
      filter: { type: { eq: "campaign" }, lang: { eq: $lang } }
    ) {
      edges {
        node {
          uid
          prismicId
          data {
            title {
              text
            }
          }
        }
      }
    }
    institutions: allPrismicDocument(
      filter: { type: { eq: "institution" }, lang: { eq: $lang } }
    ) {
      edges {
        node {
          uid
          prismicId
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/updates.js